import { memo } from 'react'

import { Button, Text } from '@cash-me/react-components'

import { Col, Grid } from 'components/grid'

import { homeRenovationSimulationSteps } from './data'
import * as S from './styles'

type Props = {
  onClick: () => void
}

export const HomeRenovationSimulationSteps = memo(({ onClick }: Props) => (
  <S.Section aria-labelledby="home-renovation-simulation-steps-title">
    <Grid col={{ phone: 1, tablet: 12 }}>
      <Col col={{ tablet: 12, desktop: 10 }} start={{ desktop: 2 }}>
        <S.Content>
          <Text
            id="home-renovation-simulation-steps-title"
            as="h2"
            size="heading2"
            weight="medium"
            color="var(--colors-neutral-text-default)"
          >
            Como fazer um Crédito para <S.Highlight>Reforma de Casa?</S.Highlight>
          </Text>

          <S.Introduction size="bodySmall" color="var(--colors-neutral-text-default)">
            O simulador de <strong>Empréstimo com Garantia de Imóvel</strong> da CashMe apresenta suas opções de
            crédito. Além de visualizar as taxas, você também pode conferir os indexadores, prazos, valores das parcelas
            e muito mais.
          </S.Introduction>

          <S.StepList>
            {homeRenovationSimulationSteps.map(({ id, order, icon, title, description }) => (
              <S.StepCard key={id} $order={order}>
                <S.StepHeader>
                  <S.IconWrapper aria-hidden>{icon}</S.IconWrapper>
                  <Text as="h3" size="heading5" weight="medium" color="var(--colors-neutral-text-default)">
                    {title}
                  </Text>
                </S.StepHeader>
                <S.StepDescription size="body1" color="var(--colors-neutral-text-weak)">
                  {description}
                </S.StepDescription>
              </S.StepCard>
            ))}
          </S.StepList>

          <S.Cta>
            <Button
              aria-label="Simular empréstimo para reforma de casa agora"
              size="lg"
              type="button"
              variants="text-only"
              onClick={onClick}
            >
              Simular agora
            </Button>
          </S.Cta>
        </S.Content>
      </Col>
    </Grid>
  </S.Section>
))

HomeRenovationSimulationSteps.displayName = 'HomeRenovationSimulationSteps'
